var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about screen"},[_c('div',{staticClass:"flex justify-center flex-direction align-center"},[_c('div',{staticClass:"text-lg text-center margin-tb padding-tb"},[_vm._v(" 欢迎来到艾力特评价助手 ")]),_c('van-button',{attrs:{"type":"info","round":"","size":"normal"},on:{"click":_vm.goHome}},[_vm._v("登 录")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }